import React, { useState, useEffect } from 'react'
import { Form, FormGroup, Label, Input, Button } from 'reactstrap'
import { updateData } from '../../lib/sessionschedule'
import { ToastNotification } from '../Lessons/CourseReport/CourseReportComponents'

const ScheduleNote = ({ value, setValue, scheduleId }) => {
	const [newAnswer, setNewAnswer] = useState(value ? value : '')
	const [saving, setSaving] = useState(false)
	const [toastMessage, setToastMessage] = useState('')
	const [showToast, setShowToast] = useState(false)

	const showToastMessage = (message) => {
		setToastMessage(message)
		setShowToast(true)
		setTimeout(() => setShowToast(false), 3000)
	}

	const handleSubmit = async (e) => {
		e.preventDefault()
		setSaving(true)

		try {
			setValue(newAnswer)

			await updateData({
				id: scheduleId,
				note: newAnswer
			})

			showToastMessage('Update successful!')
		} catch (error) {
			console.error('Error updating schedule note:', error)
		} finally {
			setSaving(false)
		}
	}

	useEffect(() => {
		setNewAnswer(value)
	}, [value])

	return (
		<Form method="post" onSubmit={handleSubmit}>
			<ToastNotification show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />
			<div className="col-12">
				<FormGroup>
					<Label className="form-control-label">Note</Label>
					<Input
						type="textarea"
						className="form-control"
						value={newAnswer}
						onChange={(e) => setNewAnswer(e.target.value)}
						rows="4"
						disabled={saving}
					/>
				</FormGroup>
			</div>
			<div className="d-flex justify-content-between mt-4">
				<Button type="submit" color="primary" disabled={saving}>
					{saving ? 'Updating...' : 'Update'}
				</Button>
			</div>
		</Form>
	)
}

export { ScheduleNote }
